var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7216 2.5L18.6599 16.25C18.7331 16.3767 18.7716 16.5204 18.7716 16.6667C18.7716 16.8129 18.7331 16.9566 18.6599 17.0833C18.5868 17.21 18.4816 17.3152 18.3549 17.3883C18.2282 17.4615 18.0845 17.5 17.9382 17.5H2.06158C1.9153 17.5 1.7716 17.4615 1.64492 17.3883C1.51824 17.3152 1.41305 17.21 1.33991 17.0833C1.26677 16.9566 1.22827 16.8129 1.22827 16.6667C1.22827 16.5204 1.26678 16.3767 1.33992 16.25L9.27825 2.5C9.35139 2.37333 9.45659 2.26814 9.58327 2.19501C9.70995 2.12188 9.85364 2.08337 9.99992 2.08337C10.1462 2.08337 10.2899 2.12188 10.4166 2.19501C10.5432 2.26814 10.6484 2.37333 10.7216 2.5ZM3.50492 15.8333H16.4949L9.99992 4.58334L3.50492 15.8333ZM9.16658 13.3333H10.8333V15H9.16658V13.3333ZM9.16658 7.5H10.8333V11.6667H9.16658V7.5Z",
    fill: "#BE8800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.3f9cfb14a078543a2652cc96f272338e.svg";
export { ForwardRef as ReactComponent };